// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "FourOhFour-module--bx--text-truncate--end--m-WeM";
export var bxTextTruncateFront = "FourOhFour-module--bx--text-truncate--front--LXMKF";
export var container = "FourOhFour-module--container--CHCLN";
export var fourOhFour = "FourOhFour-module--four-oh-four--aLt5V";
export var gradient = "FourOhFour-module--gradient--dIxR7";
export var heading = "FourOhFour-module--heading--fPIHb";
export var link = "FourOhFour-module--link--t+Ni8";
export var list = "FourOhFour-module--list--ksm3f";
export var paragraph = "FourOhFour-module--paragraph--HSJZG";